import React, { useEffect, useState } from 'react'
import { Alert, Button, Form, Image, Input, Modal, Select, Table, Tabs } from 'antd'
import axios from 'axios'
import { Card, Col, Container, Row } from 'react-bootstrap'
import { AUTH_URL } from '../constants'
import { AppleOutlined, CloseOutlined, EditFilled, SaveOutlined, SearchOutlined, UserAddOutlined } from '@ant-design/icons'
import { notify, notify_success, toastStyle } from '../pages/LoginPage'
import { IoIosPerson, IoMdArrowDropright } from "react-icons/io";
import { MdPersonSearch, MdWorkOutline } from "react-icons/md"
import { PiAddressBookLight } from "react-icons/pi"
import { IClient } from '../factory/interfaces'
import { useDispatch } from 'react-redux'
import { getMetaData } from '../actions/metaActions'
import { IoPersonCircleOutline } from 'react-icons/io5'
import PDFViewer from './commons/PDFViewer'
const { TabPane } = Tabs

//Interfaces
export interface IUser {
        _id: string | undefined,
        surname: string | undefined,
        other_names: string | undefined,
        phone: string | number | undefined,
        email: string | number | undefined,
        branch: string[]| undefined,
        role: string | number | undefined,
        active?: boolean
    }

export interface IPlant  {
  name: string,
  _id: string
}

const ClientsTable = () => {

    //variable/states
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [userLoaded, setUserLoaded] = useState(false);
    const [newUserSurname, setnewUserSurname]= useState<string | undefined>()
    const [newUserOthername, setnewUserOthername]= useState<string | undefined>()
    const [newUserEmail, setnewUserEmail]= useState<string | undefined>()
    const [newUserPhone, setnewUserPhone]= useState<string | undefined>()
    const [newUserPassword, setnewUserPassword]= useState<string | undefined>()
    const [newUserPasswordConfirm, setnewUserPasswordConfirm]= useState<string | undefined>()
    const [showNewUserForm, setShowNewUserForm]= useState<boolean>(false)
    const [confirmLoading, setConfirmLoading]= useState<boolean>(false)
    const [plants, setPlants]= useState<IPlant[]>()
    const [selectedPlant, setSelectedPlant] = useState<string>();
    const [reloadComponent, setReloadComponent] = useState(false);
    const [editMode, setEditMode]= useState<boolean>(false)
    const [userData, setUserData] = useState<IClient | null>()
    const [userSurname, setUserSurname]= useState<string | undefined>()
    const [userOthername, setUserOthername]= useState<string | undefined>()
    const [userEmail, setUserEmail]= useState<string | undefined>()
    const [userPhone, setUserPhone]= useState<string | undefined>()
    const [userPlant, setUserPlant]= useState<string | undefined>()
    const [selectedUser, setSelectedUser]= useState<IUser>()
    const [usersLoaded, setUsersLoaded] = useState(false);
    const [clients, setClients] = useState<IClient[]>();
    const [loadingClientUsers, setLoadingClientUsers] = useState(false)
    const [marchedClient, setMarchedClient]= useState<string | null>()
    const [editingClient, setEditingClient]= useState(false)

//Get Client users
    const getClientUsers = async()=>{
        try {

            setLoadingClientUsers(true)
            const users_request_response = await axios.get(`${AUTH_URL}/clients`, {withCredentials: true})
            setLoadingClientUsers(false)
            if(users_request_response.data.success){
                setUsersLoaded(true)
                setClients(users_request_response.data.clients)
              
            }else{
                setUsersLoaded(false)

             
                notify(users_request_response.data.message, toastStyle,)

            }

        } catch (error: any) {  
             notify(error.message, toastStyle,)
           
        }
    }

    const clearUserData = ()=> setUserData(null)

    //Components


  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
    clearUserData()
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    clearUserData()
  };

  const clearFields = ()=>{
    setnewUserSurname('')
    setnewUserEmail('')
    setnewUserOthername('')
    setnewUserPhone('')
    setnewUserPassword('')
    setnewUserPasswordConfirm('')
  }

  const handleRowClick = async (record: any) => {
       setSelectedUser(record._id)
        const user_data = await axios.get(`${AUTH_URL}/clients/${record._id}`)
        if(user_data.data.success){

            setUserData(user_data.data.client)
            setUserLoaded(true)
            showModal()
        }
  }

  const columns = [
  {
    title: 'No.',
    dataIndex: 'count',
    render: (text:any, record:any, index:any) => index + 1,
  },
  {
    title: 'Surname',
    dataIndex: 'surname',
    key: 'surname',
  },
    {
    title: 'Given name',
    dataIndex: 'given_name',
    key: 'given_name',
  },
  {
    title: 'Gender',
    dataIndex: 'gender',
    key: 'gender'

  },
  {
    title: 'ID Type',
    dataIndex: 'id_type',
    key: 'id_type'
  },
  {
    title: 'ID Number',
    dataIndex: 'id_number',
    key: 'id_number'
  },
  {
    title: 'District',
    dataIndex: 'district',
    key: 'district'
  },
  {
    title: 'Phone Number',
    dataIndex: 'phone',
    key: 'phone',
  },
   {
    title: 'Branch',
    dataIndex: 'branch',
    key: 'branch',
  },
  {
    title: 'Action',
    dataIndex: '',
    key: '_id',
    render: (text: string, record: any) => <Button onClick={()=>handleRowClick(record)}>View</Button>,
  },


]

  const getBranchNames = async()=> {
    
  const response = await axios.get(`${AUTH_URL}/branch-names`)
  if(response.data.success){
      setPlants(response.data.branches)
  }else{
    notify('There are no branches in the database', toastStyle)
  }
  } 

  const handleEditClient = async()=>{
    setEditingClient(true)
    try {
      const response = await axios.patch(`${AUTH_URL}/clients/${userData?._id}`, userData, {withCredentials: true})
      setEditingClient(false)
      if(response.data.success){
        notify_success('Client details updated successfully', toastStyle)
        setReloadComponent(true)
        setIsModalOpen(false)
      }else{

        notify(response.data.message, toastStyle)
      }
      
    } catch (error: any) {
      setEditingClient(false)
      notify(error.message, toastStyle)
      
    }
      
  }
  
  useEffect(()=>{
    getBranchNames()
    getClientUsers()
  },[reloadComponent])

  const dispatch = useDispatch()

  useEffect(()=>{
    dispatch(getMetaData() as any)
  }, [])

  const searchClients = (value: string, callback: Function) => {
      axios.post(`${AUTH_URL}/clients/search`, {name: value}, {withCredentials: true})
          .then((response) => {
          const data = response.data.clients.map((client: IClient) => ({
              value: client._id,
              text: `${client.surname} ${client.given_name} (${client.phone})`,
          }))
          callback(response.data.clients);
          })
          .catch((error) => {
          notify(`${error.message}`, toastStyle)
          callback([])
          })
      }
  
  const handleSearchClient = (newValue: string) => {
      searchClients(newValue, setClients)
    }

  return (
    <Container fluid>
     <Row>
       <Col>
          <h4 className='medium text-uppercase fw-bold' style={{color: '#052c65', fontSize: 16}}> <IoMdArrowDropright />Clients</h4>
       </Col>

       <Col className='d-flex justify-content-end' lg={3} md={3}>
       {clients &&
          <Button style={{width: '100%'}} type='link' className='rounded-4 border' icon={<MdPersonSearch />}> 
              SEARCH CLIENT
              <Input
                placeholder="Enter name, or phone number"
                onChange={(e)=>handleSearchClient(e.target.value)}
                className='rounded-4 border-0'
                style={{
                  border: 'none',
                  outline: 'none',
                  boxShadow: 'none',
                  borderRight: '0'
                }}
              />
            </Button>}

       </Col>
      </Row>
      <Row className='my-2'>
      {clients &&
      
          <Table style={{borderRadius: 0}} bordered dataSource={clients} columns={columns}/>
      }
      
      </Row>

        {(userData && userLoaded) && 
        
         <Modal width={800} open={isModalOpen} onOk={handleOk} onCancel={handleCancel}
         title={`Client Details`}
         centered
         footer={[
                    editMode 
                    ? [
                        <Button loading={editingClient} className='rounded-0 text-uppercase' key="edit_user" type='primary' onClick={handleEditClient}>
                           <span><SaveOutlined /></span>Save Changes
                         </Button>,
                         <Button className='rounded-0 text-uppercase' key="edit_mode_off" onClick={(e)=>setEditMode(false)}>
                           <span><CloseOutlined /> </span>Cancel Editing
                         </Button>,

                     ]
                    : 
                      [

                      <Button className='rounded-0 text-uppercase' key="edit_mode_on" onClick={(e)=>setEditMode(true)}>
                        <span><EditFilled /></span>Edit User
                      </Button>,
                      <Button  className='rounded-0 text-uppercase' key="cancel" onClick={handleCancel}>
                      <CloseOutlined />   Cancel
                      </Button>

                      ]
                ]}
         >
         {editMode &&

         <Alert
            message="You are now in edit mode"
            description="Only surname, given name, email, phone number, and ID number can be edited"
            type="info"
            showIcon
            className='rounded-0 my-2 py-2'
          />
  
         }
         <Card className='p-2 rounded-0'>
         <Tabs defaultActiveKey='1'>
          <TabPane
            tab={
              <span>
                <IoIosPerson style={{marginRight: "5px"}}/>
                Personal Details
              </span>
            }
            key="1"
          >
          <Form
                layout="vertical"
                    >
                    <Row>
                    <Col md={4}>
                    <Image src={`${AUTH_URL}/photos/clients/${userData.photo}`}>
                    
                    </Image>
                    
                    </Col>
                    <Col>
                     <Row>
                    <Col>
                    <Form.Item 
                    label="Surname" 
                    rules={[{required: true, message: "Surname is required!"}]}
                    name="surname"
                    initialValue={userData.surname}
                    >
                        <Input readOnly={!editMode} value={userSurname} 
                        onChange={(e) =>
                                setUserData((prevUserData: any) => ({
                                    ...prevUserData,
                                    surname: e.target.value,
                                }))
                            }
                         />
                    </Form.Item>
                    
                    </Col>
                    <Col>
                       
                    <Form.Item label="Given name"
                    rules={[{required: true, message: "Other name is required!"}]}
                    name="given_name"
                    initialValue={userData.given_name}
                    >
                        <Input readOnly={!editMode} value={userOthername} 
                        onChange={(e) =>
                                setUserData((prevUserData: any) => ({
                                    ...prevUserData,
                                    given_name: e.target.value,
                                }))
                            }  
                        />
                    </Form.Item>
                    
                    </Col>
                    
                    </Row>
                    <Row>
                    <Col>
                    <Form.Item label="ID type"
                    rules={[{required: true, message: "Other name is required!"}]}
                    name="id_type"
                    initialValue={userData.id_type}
                    >
                        <Input readOnly value={userOthername} 
                        onChange={(e) =>
                                setUserData((prevUserData: any) => ({
                                    ...prevUserData,
                                    other_names: e.target.value,
                                }))
                            }  
                        />
                    </Form.Item>
                    
                    </Col>
                    <Col>
                     <Form.Item label="ID Number"
                    rules={[{required: true, message: "Id number is required!"}]}
                    name="id_number"
                    initialValue={userData.id_number}
                    >
                        <Input readOnly={!editMode} value={userOthername} 
                        onChange={(e) =>
                                setUserData((prevUserData: any) => ({
                                    ...prevUserData,
                                    id_number: e.target.value,
                                }))
                            }  
                        />
                    </Form.Item>
                    
                    </Col>
                    
                    </Row>
                    <Row>
                    <Col>
                    <Form.Item 
                      label="Gender"
                      rules={[{required: true, message: "Gender is required!"}]}
                      name="gender"
                      initialValue={userData.gender}

                      >
                        <Input readOnly
                          onChange={(e) =>
                                setUserData((prevUserData: any) => ({
                                    ...prevUserData,
                                    gender: e.target.value,
                                }))
                            }
                         />
                    </Form.Item>
                    
                    </Col>
                    <Col>
                    <Form.Item 
                      label="Branch"
                      rules={[{required: true, message: "Branch is required!"}]}
                      name="branch"
                      initialValue={userData.branch}

                      >
                        <Input readOnly
                          onChange={(e) =>
                                setUserData((prevUserData: any) => ({
                                    ...prevUserData,
                                    branch: e.target.value,
                                }))
                            }
                         />
                    </Form.Item>
                    
                    </Col>
                    </Row>
                    <Row>
                    </Row>
                    <Row>
                      <Col>
                      <Form.Item 
                      label="Email address"
                      rules={[{required: true, message: "Email address is required!"}]}
                      name="email"
                      initialValue={userData.email}

                      >
                          <Input readOnly={!editMode} value={userEmail} 
                            onChange={(e) =>
                                  setUserData((prevUserData: any) => ({
                                      ...prevUserData,
                                      email: e.target.value,
                                  }))
                              }
                          />
                      </Form.Item>
                      
                      </Col>
                      <Col>
                        <Form.Item
                          label="Phone number"
                          name="phone"
                          rules={[{ required: true, message: "User must belong to a branch!" }]}
                          initialValue={userData.phone}
                        >
                          <Input readOnly={!editMode} value={userEmail} 
                            onChange={(e) =>
                                  setUserData((prevUserData: any) => ({
                                      ...prevUserData,
                                      phone: e.target.value,
                                  }))
                              }
                          />
                      
                        </Form.Item>
                      
                      </Col>
                    </Row>
                    
                    </Col>
                    
                    </Row>

                   
                   

                </Form>
            
          </TabPane>
          <TabPane
            tab={
              <span>
                <MdWorkOutline style={{marginRight: "5px"}} />
                Employment Details
              </span>
            }
            key="2"
          >
          <Form
                layout="vertical"
                    >
                    <Form.Item 
                    label="Occupation" 
                    rules={[{required: true, message: "Surname is required!"}]}
                    name="surname"
                    initialValue={userData.occupation}
                    >
                        <Input disabled={!editMode} value={userSurname} 
                        onChange={(e) =>
                                setUserData((prevUserData: any) => ({
                                    ...prevUserData,
                                    surname: e.target.value,
                                }))
                            }
                         />
                    </Form.Item>
                    <Form.Item label="Employer"
                    rules={[{required: true, message: "Other name is required!"}]}
                    name="other_names"
                    initialValue={userData.employer?.name}
                    >
                        <Input disabled={!editMode} value={userOthername} 
                        onChange={(e) =>
                                setUserData((prevUserData: any) => ({
                                    ...prevUserData,
                                    other_names: e.target.value,
                                }))
                            }  
                        />
                    </Form.Item>
                    <Form.Item 
                    label="Employer Phone Number"
                    rules={[{required: true, message: "Email is required!"}]}
                    name="email"
                    initialValue={userData.employer?.phone}

                    >
                        <Input disabled={!editMode} value={userEmail} 
                          onChange={(e) =>
                                setUserData((prevUserData: any) => ({
                                    ...prevUserData,
                                    email: e.target.value,
                                }))
                            }
                         />
                    </Form.Item>
                    <Form.Item 
                      label="Employer address"
                      rules={[{required: true, message: "Phone number is required!"}]}
                      name="employer_address"
                      initialValue={userData.employer?.address}

                      >
                        <Input disabled={!editMode}
                          onChange={(e) =>
                                setUserData((prevUserData: any) => ({
                                    ...prevUserData,
                                    phone: e.target.value,
                                }))
                            }
                         />
                    </Form.Item>
                </Form>
            
          </TabPane>

          {/* Address Tab */}
          <TabPane
            tab={
              <span>
                <PiAddressBookLight style={{marginRight: "5px"}} />
                Address Details
              </span>
            }
            key="3"
          >
          <Form
                layout="vertical"
                    >
                    <Form.Item 
                    label="District" 
                    rules={[{required: true, message: "District is required!"}]}
                    name="district"
                    initialValue={userData.district}
                    >
                        <Input disabled
                         />
                    </Form.Item>
                    <Form.Item 
                    label="Subcounty" 
                    rules={[{required: true, message: "Surname is required!"}]}
                    name="sub_county"
                    initialValue={userData.sub_county}
                    >
                        <Input disabled={!editMode} value={userSurname} 
                        onChange={(e) =>
                                setUserData((prevUserData: any) => ({
                                    ...prevUserData,
                                    surname: e.target.value,
                                }))
                            }
                         />
                    </Form.Item>
                    <Form.Item label="Village"
                    rules={[{required: true, message: "Other name is required!"}]}
                    name="village"
                    initialValue={userData.village}
                    >
                        <Input disabled={!editMode} value={userOthername} 
                        onChange={(e) =>
                                setUserData((prevUserData: any) => ({
                                    ...prevUserData,
                                    other_names: e.target.value,
                                }))
                            }  
                        />
                    </Form.Item>
                    <Form.Item 
                    label="Chairperson's name"
                    rules={[{required: true, message: "name is required!"}]}
                    name="chairman_name"
                    initialValue={userData.chairman?.name}

                    >
                        <Input disabled={!editMode} value={userEmail} 
                          onChange={(e) =>
                                setUserData((prevUserData: any) => ({
                                    ...prevUserData,
                                    email: e.target.value,
                                }))
                            }
                         />
                    </Form.Item>
                    <Form.Item 
                      label="Chairperson's Phone"
                      rules={[{required: true, message: "Phone number is required!"}]}
                      name="employer_address"
                      initialValue={userData.chairman?.phone}

                      >
                        <Input disabled={!editMode}
                          onChange={(e) =>
                                setUserData((prevUserData: any) => ({
                                    ...prevUserData,
                                    phone: e.target.value,
                                }))
                            }
                         />
                    </Form.Item>
                </Form>
            
          </TabPane>
         
         </Tabs>
         
                
            </Card>
      </Modal>
        }
     
    </Container>
    
  )
}

export default ClientsTable
